export const apiConfig = {
  basePath: process.env.REACT_APP_API_BASE_URL 
    ? `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_API_BASE_URL.endsWith('/') ? '' : '/'}`
    : 'https://pro.vibelinksapp.com/api/',
  socketPath: process.env.REACT_APP_SOCKET_URL || 'https://pro.gocarhub.app:3000',
  defaultImageUrl: process.env.REACT_APP_DEFAULT_IMAGE_URL || 'https://pro.vibelinksapp.com/default/user.jpg',
  endpoints: {
    //Auth and User Endpoints
    signup: 'signup',
    signin: 'login',
    socialSignin: 'social-login',
    forgotPassword: 'forgot-password',
    changePassword: 'change-password',
    myVibe: 'my-vibe'
  }
}
